module.exports = require('./helpers/bundle-url').getBundleURL('4oUxu') + "logo-dark.eefe0b7f.svg";